<template>
  <div>
    <header-nav></header-nav>
    <HomePage v-if="$route.name==='index'" style="width: 1200px;margin: auto" />
    <keep-alive v-else include="goodslist">
      <router-view style="min-height: calc(100vh - 392px)"></router-view>
    </keep-alive>
    <footer-nav></footer-nav>
  </div>
</template>

<script>
import HeaderNav from "./header-nav";
import FooterNav from "./footer-nav";
import HomePage from "./homepage";
export default {
  components: { HeaderNav, FooterNav, HomePage },
  name: "Home",
  data() {
    return {};
  },
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less'>
@import "../css/common.less";
</style>
